import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import clsx from 'clsx';
export const TileTable = (props) => {
    const { children, className = '', column } = props;
    return (_jsx("div", Object.assign({ className: clsx('overflow-hidden') }, { children: _jsx("div", Object.assign({ className: clsx('grid gap-y-20', 'w-[calc(100% + 1px)]', 'border-l border-r-0 border-y-0 border-solid border-transparent -mx-[1px]', column || 'grid-cols-3', className) }, { children: children })) })));
};
